import React from "react";

const ProductCard = ({ image, title, size, thickness }: any) => {
  return (
    <div className="w-full rounded-lg overflow-hidden shadow-md bg-white hover:shadow-lg transition mb-10">
      {/* Image */}
      <div className="h-64 bg-gray-100 flex items-center justify-center">
        <img src={image} alt={title} className="object-cover h-full w-full" />
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        <p className="text-sm text-gray-500">Size: {size}</p>
        <p className="text-sm text-gray-500">Thickness: {thickness}</p>
      </div>
    </div>
  );
};

export default ProductCard;
